import { ApplicationConfig } from '@angular/core';
import {
  provideRouter,
  withPreloading,
  PreloadAllModules,
  withViewTransitions,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';
import { provideClientHydration, withHttpTransferCacheOptions } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { routes } from './app.routes';
import { httpCacheInterceptor } from './http-cache.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      // Preload all lazy chunks in the background after initial load
      withPreloading(PreloadAllModules),
      // Smooth page transitions using the View Transitions API
      withViewTransitions(),
      // Restore scroll position on back/forward; enable anchor scrolling
      withInMemoryScrolling({
        scrollPositionRestoration: 'enabled',
        anchorScrolling: 'enabled',
      }),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
    ),
    // Transfer HTTP responses from SSR to client — avoids duplicate requests
    provideClientHydration(
      withHttpTransferCacheOptions({ includePostRequests: false }),
    ),
    // Use the native Fetch API (faster than XHR, works well with SSR)
    provideHttpClient(withFetch(), withInterceptors([httpCacheInterceptor])),
  ],
};